export enum Environments {
  dev = 0,
  test = 1,
  stage = 2,
  stageweb = 5,
  prod = 3,
  local = 4,
}
